export default function LoginAPIvalidation(validationErrors = {}) {
  // Return default error messages if no validation errors provided
  if (!validationErrors || typeof validationErrors !== 'object') {
    return {
      number: 'Mobile number is required',
      password: 'Password is required',
      otp: 'OTP is required'
    };
  }

  // Map server validation errors to field names
  const errors = {};
  
  if (validationErrors.number) {
    errors.number = validationErrors.number;
  }
  
  
  if (validationErrors.password) {
    errors.password = validationErrors.password;
  }
  
  if (validationErrors.otp) {
    errors.otp = validationErrors.otp;
  }

  return errors;
}